import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShippingService } from '../../services/api-services/shipping.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-clear-rx-pop-up',
  templateUrl: './clear-rx-pop-up.component.html',
  styleUrl: './clear-rx-pop-up.component.scss'
})
export class ClearRxPopUpComponent {
  isLoading: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ClearRxPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private shippingService: ShippingService,
    private toastr: ToastrService,
  ) { }

  // Clear Rx ID from server and refresh list
  clearRxInput() {
    if (!this.data || this.data.item.refill_request_id == null) return;
    const payload = {
      "refill_request_id": this.data.item?.refill_request_id,
      "user_id": this.data?.item?.user_id,
      "request_type": this.data.item?.request_type
    };
    this.isLoading = true;
    this.shippingService.clear_rx_num_id(payload).subscribe({
      next: (res: any) => {
        if (res?.body?.success) {
          this.toastr.success(res?.body?.message || 'Rx ID cleared successfully');
          this.dialogRef.close(res?.body?.success);
          this.isLoading = false;
        } else {
          this.toastr.error(res?.body?.message || 'Failed to clear Rx ID');
          this.isLoading = false;
        }
      },
      error: (err: any) => {
        console.error('Server error while clearing Rx ID', err);
        this.toastr.error('Server error while clearing Rx ID');
        this.isLoading = false;
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
